import React, { useEffect, useState } from 'react';
import {
  CloudServerOutlined,
  DashboardOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  ProfileOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, Typography, Popover, Space } from 'antd';
import { ButtonComponent } from '@comps/components';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { logout } from '../modules/userManagement/auth/authSlice';
import { logoutReq } from '../modules/userManagement/auth/requests';
import ModuleRoutes from '../modules/routes';
import { makeRequestStateless } from '@utils/helpers';
import { Icon } from '@iconify/react';
import "./styles.css"

const { Header, Sider, Content } = Layout;
const Layouts = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const [updatedMenus, setUpdatedMenus] = useState(menuItems);
  const [selectedKey, setSelectedKey] = useState('dashboard')
  const [collapsed, setCollapsed] = useState(false);
  const [collapsedWidth, setCollapsedWidth] = useState("0");
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { Title, Text } = Typography

  useEffect(() => {
    if (location.pathname === "/") {
      setSelectedKey("/dashboard")
      return
    }
    setSelectedKey(location.pathname)
  }, [location.pathname])


  const dropdown = () => (
    <>
      <div>
        {/* add links for profile */ }
        <div style={ { margin: '8px 0' } }>
          <Link to="/profile">
            <Text>Profile</Text>
          </Link>
        </div>

        <ButtonComponent type="text" style={ {
          padding: '0',
        } } onClick={ handleLogout } text={ "Logout" } danger />
      </div>
    </>
  );
  //end report
  const handleLogout = () => {
    makeRequestStateless(logoutReq, null, onSuccessLogout, onErrorLogout);
  }


  const onSuccessLogout = (req, res) => {
    setUpdatedMenus([]);
    localStorage.clear();
    dispatch(logout())
    navigate('/')
  }

  const onErrorLogout = (err, res) => {
    console.log(err, res);
  }


  const onNavigate = (key) => (
    navigate(key)
  )

  const onBreakPoint = (value) => {
    setCollapsed(value)
    setCollapsedWidth(value ? "0" : "64")
  }


  return (
    <Layout className='h-100' id='main-layout'>
      <Sider collapsible breakpoint="lg" collapsedWidth={ collapsedWidth }
        collapsed={ collapsed } trigger={ null }
        onBreakpoint={ onBreakPoint } >
        <div className='m-16'>
          { collapsed ?
            <img src={ require('@assets/images/image170.png') } alt='icon' /> :
            <img src={ require('@assets/images/KLOK.png') } alt="logo" />
          }
        </div>

        <Menu
          onClick={ ({ key }) => {
            onNavigate(key)
          } }
          className='m-8'
          defaultSelectedKeys={ ['/dashboard'] }
          selectedKeys={ [selectedKey] }
          items={ updatedMenus }
        />
      </Sider>

      <Layout>
        <Header className='header'>
          <Space className='header-nav'>
            <Button
              type="button"
              className='cursor'
              icon={ collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined /> }
              onClick={ () => setCollapsed(!collapsed) }
            />

            <Popover content={ dropdown } trigger="click" className='cursor'>
              <Icon icon='teenyicons:user-circle-outline' fontSize={ 20 } className='mx-4 -my-4' />
              <Text>{ authUser }</Text>
            </Popover>
          </Space>

        </Header>
        <Content
          style={ {
            margin: '24px 16px',
            padding: 24,
          } }
          className='bg-white'
        >
          <ModuleRoutes />
        </Content>
      </Layout>
    </Layout>
  );
};
export default Layouts;

const menuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: 'Dashboard',
  },
  {
    key: '/tenants',
    icon: <ProfileOutlined />,
    label: 'Tenants',
  },
  {
    key: '/servers',
    icon: <CloudServerOutlined />,
    label: 'Servers',
  },
];